import { useState } from "react";
import { OpenTabsContext } from "./OpenTabsContext";
import { logClientError } from "./utils/clientErrorLogger";

const navigateToHome = () => {
  if (window.location.pathname !== "/") {
    window.history.pushState({}, "", "/");
  }
  window.dispatchEvent(new PopStateEvent("popstate"));
};

const navigateToPath = (path: string) => {
  const currentPathWithSearch =
    window.location.pathname + window.location.search;
  if (currentPathWithSearch !== path) {
    window.history.pushState({}, "", path);
  }
  window.dispatchEvent(new PopStateEvent("popstate"));
};

const parseOpenGlobalTabs = (rawValue: string | null): string[] => {
  if (!rawValue) {
    return [];
  }

  try {
    const parsed = JSON.parse(rawValue);
    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed.map((tab) =>
      typeof tab === "string" && tab.startsWith("customer-")
        ? tab.replace("customer-", "user-")
        : tab
    );
  } catch (error) {
    void logClientError({
      source: "localStorage.parse",
      error,
      extra: {
        key: "openGlobalTabs",
        valuePreview: rawValue.slice(0, 200),
      },
    });
    localStorage.removeItem("openGlobalTabs");
    return [];
  }
};

export const OpenTabsProvider = (props: any) => {
  let openTabLength = parseOpenGlobalTabs(
    localStorage.getItem("openGlobalTabs")
  );

  if (openTabLength.length > 0) {
    if (openTabLength.length > 6) {
      openTabLength.shift();
      localStorage.setItem("openGlobalTabs", JSON.stringify(openTabLength));
    } else {
    }
  }
  const [openGlobalTabs, setOpenGlobalTabs] = useState<any[]>(openTabLength);
  const [removeGlobalTabName, setRemoveGlobalTabName] = useState<string>("");
  const addGlobalTab = (tab: string) => {
    let tabArray = tab.toString().split("-");
    let tabName2 = "";
    if (tabArray && tabArray.length >= 2) {
      tabName2 = tabArray[0] + "-" + tabArray[1];
    }
    if (openGlobalTabs) {
      for (let i = 0; i < openGlobalTabs.length; i++) {
        if (
          openGlobalTabs[i].includes(tab) ||
          (tabName2 && openGlobalTabs[i].includes(tabName2))
        ) {
          return;
        }
      }
    }

    if (openGlobalTabs.length >= 6) {
      navigateToHome();
      return;
    }
    setOpenGlobalTabs([...openGlobalTabs, tab]);
    localStorage.setItem(
      "openGlobalTabs",
      JSON.stringify([...openGlobalTabs, tab])
    );
  };

  const removeGlobalTab = (tab: string) => {
    const newTabs = openGlobalTabs.filter((t) => t !== tab);
    setOpenGlobalTabs(newTabs);
    setRemoveGlobalTabName(tab);
    localStorage.setItem("openGlobalTabs", JSON.stringify(newTabs));
    if (openGlobalTabs.length === 1 && newTabs.length === 0) {
      // 只有一个tab时，移除后直接跳转首页
      const closeTabType = tab.split("-")[0];
      if (closeTabType == "app") {
        navigateToPath(
          '/applications?filter={"status":"New","subStatus":"Verification Pending"}'
        );
      } else if (closeTabType == "loan") {
        navigateToPath(
          '/loans?filter={"status":"active","curStatus":"OK","filterRemainingterm":"<12 Months"}'
        );
      } else if (closeTabType == "user" || closeTabType == "customer") {
        navigateToPath('/customers?filter={"status":"signUp2026_campaigns"}');
      } else {
        navigateToHome();
      }
    }
  };

  const removeAllGLobalTab = () => {
    setOpenGlobalTabs([]);
    setRemoveGlobalTabName("");
    localStorage.setItem("openGlobalTabs", JSON.stringify([]));

    navigateToHome();
  };

  return (
    <OpenTabsContext.Provider
      value={{
        openGlobalTabs,
        removeGlobalTabName,
        setRemoveGlobalTabName,
        addGlobalTab,
        removeGlobalTab,
        removeAllGLobalTab,
      }}
    >
      {props.children}
    </OpenTabsContext.Provider>
  );
};
